export const CLERK_ROUTES = {
  CLERK_DASHBOARD: {
    DASHBOARD: "/NewScrutinyClerkDashboard",
  },
};
